module.exports = __webpack_public_path__ + "static/2-b294cbce5fad5abc0c9c6e6a58fd9c7e.jpg";